import { useState, useEffect } from 'react';
import { API, getAuthHeader } from '../App';
import axios from 'axios';
import { toast } from 'sonner';
import { 
  Send, Building2, MapPin, Users, Search, Check, X, 
  Loader2, MessageSquare, History, ChevronRight, ChevronDown,
  RefreshCw, AlertCircle, CheckCircle, XCircle, Clock, Edit2, Trash2, Save, UserPlus, Star,
  FileText, Plus, Tag
} from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

// Categorias de templates
var CATEGORIAS = ['Manutenção', 'Promoção', 'Cobrança', 'Geral'];

function TransmissaoPage() {
  // Estados
  var [filiais, setFiliais] = useState([]);
  var [filialSelecionada, setFilialSelecionada] = useState(null);
  var [bairros, setBairros] = useState([]);
  var [bairroSelecionado, setBairroSelecionado] = useState(null);
  var [clientesSelecionados, setClientesSelecionados] = useState([]);
  var [mensagem, setMensagem] = useState('');
  var [loading, setLoading] = useState(false);
  var [loadingBairros, setLoadingBairros] = useState(false);
  var [enviando, setEnviando] = useState(false);
  var [searchBairro, setSearchBairro] = useState('');
  var [historico, setHistorico] = useState([]);
  var [showHistorico, setShowHistorico] = useState(false);
  var [loadingHistorico, setLoadingHistorico] = useState(false);
  var [detalheTransmissao, setDetalheTransmissao] = useState(null);
  var [bairrosExpandidos, setBairrosExpandidos] = useState({});
  var [resultadoEnvio, setResultadoEnvio] = useState(null);
  var [editandoFilial, setEditandoFilial] = useState(null);
  var [nomeFantasiaEdit, setNomeFantasiaEdit] = useState('');
  var [cidadeEdit, setCidadeEdit] = useState('');
  var [showAdicionarCliente, setShowAdicionarCliente] = useState(false);
  var [novoCliente, setNovoCliente] = useState({ id: '', nome: '', telefone: '', bairro: '' });
  
  // Estados de Templates
  var [templates, setTemplates] = useState([]);
  var [showTemplates, setShowTemplates] = useState(false);
  var [loadingTemplates, setLoadingTemplates] = useState(false);
  var [searchTemplate, setSearchTemplate] = useState('');
  var [editandoTemplate, setEditandoTemplate] = useState(null);
  var [novoTemplate, setNovoTemplate] = useState({ titulo: '', mensagem: '', categoria: 'Geral' });
  var [filtroCategoria, setFiltroCategoria] = useState('');

  // Carregar filiais do IXC
  useEffect(function() {
    carregarFiliais();
  }, []);
  
  // Carregar templates
  async function carregarTemplates() {
    setLoadingTemplates(true);
    try {
      var url = API + '/transmissao/templates';
      if (filtroCategoria) {
        url += '?categoria=' + encodeURIComponent(filtroCategoria);
      }
      var response = await axios.get(url, { headers: getAuthHeader() });
      setTemplates(response.data.templates || []);
    } catch (error) {
      console.error('Erro ao carregar templates:', error);
      toast.error('Erro ao carregar templates');
    } finally {
      setLoadingTemplates(false);
    }
  }
  
  // Criar template
  async function criarTemplate() {
    if (!novoTemplate.titulo.trim() || !novoTemplate.mensagem.trim()) {
      toast.error('Preencha título e mensagem');
      return;
    }
    try {
      await axios.post(API + '/transmissao/templates', novoTemplate, { headers: getAuthHeader() });
      toast.success('Template criado com sucesso!');
      setNovoTemplate({ titulo: '', mensagem: '', categoria: 'Geral' });
      carregarTemplates();
    } catch (error) {
      console.error('Erro ao criar template:', error);
      toast.error('Erro ao criar template');
    }
  }
  
  // Atualizar template
  async function atualizarTemplate(templateId) {
    if (!editandoTemplate.titulo.trim() || !editandoTemplate.mensagem.trim()) {
      toast.error('Preencha título e mensagem');
      return;
    }
    try {
      await axios.put(API + '/transmissao/templates/' + templateId, {
        titulo: editandoTemplate.titulo,
        mensagem: editandoTemplate.mensagem,
        categoria: editandoTemplate.categoria
      }, { headers: getAuthHeader() });
      toast.success('Template atualizado!');
      setEditandoTemplate(null);
      carregarTemplates();
    } catch (error) {
      console.error('Erro ao atualizar template:', error);
      toast.error('Erro ao atualizar template');
    }
  }
  
  // Excluir template
  async function excluirTemplate(templateId) {
    if (!window.confirm('Deseja excluir este template?')) return;
    try {
      await axios.delete(API + '/transmissao/templates/' + templateId, { headers: getAuthHeader() });
      toast.success('Template excluído!');
      carregarTemplates();
    } catch (error) {
      console.error('Erro ao excluir template:', error);
      toast.error('Erro ao excluir template');
    }
  }
  
  // Usar template na mensagem
  function usarTemplate(template) {
    setMensagem(template.mensagem);
    setShowTemplates(false);
    toast.success('Template "' + template.titulo + '" aplicado!');
  }
  
  // Filtrar templates pela busca
  function getTemplatesFiltrados() {
    if (!searchTemplate.trim()) return templates;
    var termo = searchTemplate.toLowerCase();
    return templates.filter(function(t) {
      return t.titulo.toLowerCase().includes(termo) || t.categoria.toLowerCase().includes(termo);
    });
  }

  async function carregarFiliais() {
    setLoading(true);
    try {
      var response = await axios.get(API + '/transmissao/filiais-ixc', { headers: getAuthHeader() });
      setFiliais(response.data.filiais || []);
    } catch (error) {
      console.error('Erro ao carregar filiais:', error);
      toast.error('Erro ao carregar filiais do IXC');
    } finally {
      setLoading(false);
    }
  }

  // Iniciar edição do nome fantasia e cidade
  function iniciarEdicaoFilial(filial, e) {
    e.stopPropagation();
    setEditandoFilial(filial.id);
    setNomeFantasiaEdit(filial.nome_fantasia || filial.nome || '');
    setCidadeEdit(filial.cidade || '');
  }

  // Salvar nome fantasia e cidade
  async function salvarConfigFilial(filialId, e) {
    e.stopPropagation();
    try {
      await axios.put(
        API + '/transmissao/filiais-ixc/' + filialId + '/config',
        { nome_fantasia: nomeFantasiaEdit, cidade: cidadeEdit },
        { headers: getAuthHeader() }
      );
      toast.success('Configuração da filial salva!');
      setEditandoFilial(null);
      carregarFiliais();
    } catch (error) {
      console.error('Erro ao salvar:', error);
      toast.error('Erro ao salvar configuração');
    }
  }

  // Excluir filial (ocultar da lista)
  async function excluirFilial(filialId, filialNome, e) {
    e.stopPropagation();
    if (!window.confirm('Deseja ocultar a filial "' + filialNome + '" da lista de transmissão?')) {
      return;
    }
    try {
      await axios.put(
        API + '/transmissao/filiais-ixc/' + filialId + '/config',
        { excluida: true },
        { headers: getAuthHeader() }
      );
      toast.success('Filial ocultada da lista');
      carregarFiliais();
    } catch (error) {
      console.error('Erro ao excluir:', error);
      toast.error('Erro ao ocultar filial');
    }
  }

  function cancelarEdicao(e) {
    e.stopPropagation();
    setEditandoFilial(null);
    setNomeFantasiaEdit('');
    setCidadeEdit('');
  }

  async function selecionarFilial(filial) {
    setFilialSelecionada(filial);
    setBairros([]);
    setBairroSelecionado(null);
    setClientesSelecionados([]);
    setLoadingBairros(true);
    setBairrosExpandidos({});

    try {
      var response = await axios.get(API + '/transmissao/clientes-por-bairro/' + filial.id, { headers: getAuthHeader() });
      setBairros(response.data.bairros || []);
      if (response.data.clientes_sem_whatsapp > 0) {
        toast.info(response.data.clientes_sem_whatsapp + ' clientes sem WhatsApp foram ignorados');
      }
    } catch (error) {
      console.error('Erro ao carregar bairros:', error);
      toast.error('Erro ao carregar clientes da filial');
    } finally {
      setLoadingBairros(false);
    }
  }

  function selecionarBairro(bairro) {
    setBairroSelecionado(bairro);
    // Selecionar todos os clientes do bairro por padrão
    setClientesSelecionados(bairro.clientes.map(function(c) { return c.id; }));
  }

  function toggleCliente(clienteId) {
    if (clientesSelecionados.includes(clienteId)) {
      setClientesSelecionados(clientesSelecionados.filter(function(id) { return id !== clienteId; }));
    } else {
      setClientesSelecionados([].concat(clientesSelecionados, [clienteId]));
    }
  }

  function selecionarTodos() {
    if (!bairroSelecionado) return;
    setClientesSelecionados(bairroSelecionado.clientes.map(function(c) { return c.id; }));
  }

  function desmarcarTodos() {
    setClientesSelecionados([]);
  }

  function toggleBairroExpandido(bairroNome) {
    setBairrosExpandidos(function(prev) {
      var novo = Object.assign({}, prev);
      novo[bairroNome] = !novo[bairroNome];
      return novo;
    });
  }

  // Adicionar cliente manualmente
  async function adicionarClienteManual() {
    if (!filialSelecionada) {
      toast.error('Selecione uma filial primeiro');
      return;
    }
    if (!novoCliente.id.trim()) {
      toast.error('Informe o ID do cliente');
      return;
    }

    try {
      var response = await axios.post(
        API + '/transmissao/filiais/' + filialSelecionada.id + '/clientes',
        {
          cliente_id: novoCliente.id.trim(),
          cliente_nome: novoCliente.nome.trim(),
          cliente_telefone: novoCliente.telefone.trim(),
          cliente_bairro: novoCliente.bairro.trim()
        },
        { headers: getAuthHeader() }
      );

      if (response.data.sucesso) {
        toast.success('Cliente adicionado à lista!');
        setShowAdicionarCliente(false);
        setNovoCliente({ id: '', nome: '', telefone: '', bairro: '' });
        // Recarregar bairros
        selecionarFilial(filialSelecionada);
      } else {
        toast.error(response.data.mensagem || 'Erro ao adicionar');
      }
    } catch (error) {
      console.error('Erro ao adicionar cliente:', error);
      toast.error('Erro ao adicionar cliente: ' + (error.response?.data?.detail || error.message));
    }
  }

  // Remover cliente manual
  async function removerClienteManual(clienteId) {
    if (!filialSelecionada) return;
    if (!window.confirm('Deseja remover este cliente da lista manual?')) return;

    try {
      await axios.delete(
        API + '/transmissao/filiais/' + filialSelecionada.id + '/clientes/' + clienteId,
        { headers: getAuthHeader() }
      );
      toast.success('Cliente removido da lista manual');
      selecionarFilial(filialSelecionada);
    } catch (error) {
      console.error('Erro ao remover:', error);
      toast.error('Erro ao remover cliente');
    }
  }

  async function enviarMensagem() {
    if (!filialSelecionada || !bairroSelecionado || clientesSelecionados.length === 0 || !mensagem.trim()) {
      toast.error('Preencha todos os campos e selecione pelo menos um cliente');
      return;
    }

    var clientesParaEnviar = bairroSelecionado.clientes.filter(function(c) {
      return clientesSelecionados.includes(c.id);
    });

    setEnviando(true);
    setResultadoEnvio(null);

    try {
      var response = await axios.post(API + '/transmissao/enviar', {
        filial_id: filialSelecionada.id,
        filial_nome: filialSelecionada.nome,
        bairro: bairroSelecionado.bairro,
        mensagem: mensagem,
        clientes: clientesParaEnviar
      }, { headers: getAuthHeader() });

      setResultadoEnvio(response.data);
      toast.success('Transmissão concluída: ' + response.data.enviados + ' enviados, ' + response.data.falhas + ' falhas');
      
      // Limpar seleção
      setClientesSelecionados([]);
      setMensagem('');
      
    } catch (error) {
      console.error('Erro ao enviar:', error);
      toast.error('Erro ao enviar mensagens: ' + (error.response?.data?.detail || error.message));
    } finally {
      setEnviando(false);
    }
  }

  async function carregarHistorico() {
    setShowHistorico(true);
    setLoadingHistorico(true);
    try {
      var response = await axios.get(API + '/transmissao/logs', { headers: getAuthHeader() });
      setHistorico(response.data.transmissoes || []);
    } catch (error) {
      console.error('Erro ao carregar histórico:', error);
      toast.error('Erro ao carregar histórico');
    } finally {
      setLoadingHistorico(false);
    }
  }

  async function verDetalheTransmissao(transmissaoId) {
    try {
      var response = await axios.get(API + '/transmissao/logs/' + transmissaoId, { headers: getAuthHeader() });
      setDetalheTransmissao(response.data);
    } catch (error) {
      console.error('Erro ao carregar detalhes:', error);
      toast.error('Erro ao carregar detalhes');
    }
  }

  // Função para remover acentos
  function removerAcentos(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  // Filtrar bairros
  var bairrosFiltrados = bairros.filter(function(b) {
    if (!searchBairro) return true;
    var bairroNormalizado = removerAcentos(b.bairro.toLowerCase());
    var buscaNormalizada = removerAcentos(searchBairro.toLowerCase());
    return bairroNormalizado.includes(buscaNormalizada);
  });

  // Total de clientes nos bairros filtrados
  var totalClientesFiltrados = bairrosFiltrados.reduce(function(acc, b) { return acc + b.total_clientes; }, 0);

  return (
    <div className="p-4 md:p-6 space-y-6" data-testid="transmissao-page">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">Lista de Transmissão</h1>
          <p className="text-slate-500 text-sm">Envio de mensagens em massa por bairro</p>
        </div>
        <div className="flex gap-2">
          <Button
            onClick={function() { setShowTemplates(true); carregarTemplates(); }}
            variant="outline"
            data-testid="btn-templates"
          >
            <FileText className="w-4 h-4 mr-2" />
            Templates
          </Button>
          <Button
            onClick={function() { setShowAdicionarCliente(true); }}
            variant="outline"
            disabled={!filialSelecionada}
            title={filialSelecionada ? 'Adicionar cliente manualmente' : 'Selecione uma filial primeiro'}
            data-testid="btn-adicionar-cliente"
          >
            <UserPlus className="w-4 h-4 mr-2" />
            Adicionar Cliente
          </Button>
          <Button
            onClick={carregarHistorico}
            variant="outline"
            data-testid="btn-historico"
          >
            <History className="w-4 h-4 mr-2" />
            Histórico
          </Button>
        </div>
      </div>

      {/* Etapas */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Etapa 1: Selecionar Filial */}
        <Card className="lg:col-span-1">
          <CardHeader className="pb-3">
            <CardTitle className="text-base flex items-center gap-2">
              <span className="w-6 h-6 bg-blue-600 text-white rounded-full flex items-center justify-center text-sm">1</span>
              Selecionar Filial
            </CardTitle>
          </CardHeader>
          <CardContent>
            {loading ? (
              <div className="flex items-center justify-center py-8">
                <Loader2 className="w-6 h-6 animate-spin text-blue-600" />
              </div>
            ) : (
              <div className="space-y-2 max-h-[300px] overflow-y-auto">
                {filiais.map(function(filial) {
                  var isSelected = filialSelecionada?.id === filial.id;
                  var isEditing = editandoFilial === filial.id;
                  
                  return (
                    <div
                      key={filial.id}
                      data-testid={'filial-' + filial.id}
                      className={'w-full p-3 rounded-lg border transition-all ' + 
                        (isSelected ? 'bg-blue-50 border-blue-500 ring-2 ring-blue-200' : 'bg-white hover:bg-slate-50 border-slate-200')}
                    >
                      {isEditing ? (
                        /* Modo de Edição */
                        <div className="space-y-2">
                          <Input
                            value={nomeFantasiaEdit}
                            onChange={function(e) { setNomeFantasiaEdit(e.target.value); }}
                            placeholder="Nome fantasia da filial"
                            className="text-sm"
                            onClick={function(e) { e.stopPropagation(); }}
                          />
                          <Input
                            value={cidadeEdit}
                            onChange={function(e) { setCidadeEdit(e.target.value); }}
                            placeholder="Cidade (ex: SAO PAULO, SANTA RITA DO PASSA QUATRO)"
                            className="text-sm"
                            onClick={function(e) { e.stopPropagation(); }}
                          />
                          <p className="text-xs text-slate-500">⚠️ A cidade filtra os clientes. Deixe vazio para não filtrar.</p>
                          <div className="flex gap-2">
                            <Button size="sm" onClick={function(e) { salvarConfigFilial(filial.id, e); }} className="flex-1 bg-green-600 hover:bg-green-700">
                              <Save className="w-3 h-3 mr-1" />Salvar
                            </Button>
                            <Button size="sm" variant="outline" onClick={cancelarEdicao}>
                              <X className="w-3 h-3" />
                            </Button>
                          </div>
                        </div>
                      ) : (
                        /* Modo Normal */
                        <div className="cursor-pointer" onClick={function() { selecionarFilial(filial); }}>
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-2 flex-1">
                              <Building2 className={'w-4 h-4 ' + (isSelected ? 'text-blue-600' : 'text-slate-400')} />
                              <span className={'font-medium ' + (isSelected ? 'text-blue-700' : 'text-slate-700')}>
                                {filial.nome_fantasia || filial.nome}
                              </span>
                            </div>
                            <div className="flex gap-1">
                              <button
                                onClick={function(e) { iniciarEdicaoFilial(filial, e); }}
                                className="p-1 hover:bg-slate-200 rounded"
                                title="Editar configurações"
                              >
                                <Edit2 className="w-3 h-3 text-slate-500" />
                              </button>
                              <button
                                onClick={function(e) { excluirFilial(filial.id, filial.nome, e); }}
                                className="p-1 hover:bg-red-100 rounded"
                                title="Ocultar filial"
                              >
                                <Trash2 className="w-3 h-3 text-red-500" />
                              </button>
                            </div>
                          </div>
                          <p className="text-xs text-slate-400 ml-6">
                            ID: {filial.id} {filial.cidade ? (filial.cidade.startsWith('!') ? ' | Exceto cidade ' + filial.cidade.substring(1) : ' | Cidade ' + filial.cidade) : ''}
                          </p>
                        </div>
                      )}
                    </div>
                  );
                })}
                {filiais.length === 0 && (
                  <p className="text-center text-slate-500 py-4">Nenhuma filial encontrada</p>
                )}
              </div>
            )}
            <Button
              onClick={carregarFiliais}
              variant="ghost"
              size="sm"
              className="w-full mt-2"
              disabled={loading}
            >
              <RefreshCw className={'w-4 h-4 mr-2 ' + (loading ? 'animate-spin' : '')} />
              Atualizar Filiais
            </Button>
          </CardContent>
        </Card>

        {/* Etapa 2: Selecionar Bairro */}
        <Card className="lg:col-span-1">
          <CardHeader className="pb-3">
            <CardTitle className="text-base flex items-center gap-2">
              <span className={'w-6 h-6 rounded-full flex items-center justify-center text-sm ' + 
                (filialSelecionada ? 'bg-blue-600 text-white' : 'bg-slate-300 text-slate-600')}>2</span>
              Selecionar Bairro
            </CardTitle>
          </CardHeader>
          <CardContent>
            {!filialSelecionada ? (
              <div className="text-center py-8 text-slate-500">
                <MapPin className="w-8 h-8 mx-auto mb-2 opacity-50" />
                <p>Selecione uma filial primeiro</p>
              </div>
            ) : loadingBairros ? (
              <div className="flex items-center justify-center py-8">
                <Loader2 className="w-6 h-6 animate-spin text-blue-600" />
              </div>
            ) : (
              <div>
                {/* Busca */}
                <div className="relative mb-3">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                  <Input
                    placeholder="Buscar bairro..."
                    value={searchBairro}
                    onChange={function(e) { setSearchBairro(e.target.value); }}
                    className="pl-9"
                    data-testid="search-bairro"
                  />
                </div>

                {/* Resumo */}
                <div className="bg-slate-100 rounded-lg p-2 mb-3 text-sm">
                  <p className="text-slate-600">
                    <span className="font-medium text-slate-800">{bairrosFiltrados.length}</span> bairros | 
                    <span className="font-medium text-slate-800 ml-1">{totalClientesFiltrados}</span> clientes
                  </p>
                </div>

                {/* Lista de Bairros */}
                <div className="space-y-1 max-h-[250px] overflow-y-auto">
                  {bairrosFiltrados.map(function(bairro) {
                    var isSelected = bairroSelecionado?.bairro === bairro.bairro;
                    var isExpanded = bairrosExpandidos[bairro.bairro];
                    return (
                      <div key={bairro.bairro}>
                        <button
                          onClick={function() { selecionarBairro(bairro); }}
                          data-testid={'bairro-' + bairro.bairro.replace(/\s+/g, '-').toLowerCase()}
                          className={'w-full p-2 rounded-lg border text-left transition-all ' + 
                            (isSelected ? 'bg-green-50 border-green-500 ring-2 ring-green-200' : 'bg-white hover:bg-slate-50 border-slate-200')}
                        >
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-2">
                              <MapPin className={'w-4 h-4 ' + (isSelected ? 'text-green-600' : 'text-slate-400')} />
                              <span className={'font-medium text-sm ' + (isSelected ? 'text-green-700' : 'text-slate-700')}>{bairro.bairro}</span>
                            </div>
                            <div className="flex items-center gap-2">
                              <span className={'text-xs px-2 py-0.5 rounded-full ' + (isSelected ? 'bg-green-100 text-green-700' : 'bg-slate-100 text-slate-600')}>
                                {bairro.total_clientes} clientes
                              </span>
                              <button
                                onClick={function(e) { e.stopPropagation(); toggleBairroExpandido(bairro.bairro); }}
                                className="p-1 hover:bg-slate-100 rounded"
                              >
                                {isExpanded ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
                              </button>
                            </div>
                          </div>
                        </button>
                        {/* Lista expandida de clientes */}
                        {isExpanded && (
                          <div className="ml-6 mt-1 mb-2 p-2 bg-slate-50 rounded-lg max-h-32 overflow-y-auto">
                            {bairro.clientes.slice(0, 10).map(function(c) {
                              return (
                                <p key={c.id} className="text-xs text-slate-600 truncate">{c.nome}</p>
                              );
                            })}
                            {bairro.clientes.length > 10 && (
                              <p className="text-xs text-slate-400 italic">+{bairro.clientes.length - 10} clientes...</p>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </CardContent>
        </Card>

        {/* Etapa 3: Mensagem e Envio */}
        <Card className="lg:col-span-1">
          <CardHeader className="pb-3">
            <CardTitle className="text-base flex items-center gap-2">
              <span className={'w-6 h-6 rounded-full flex items-center justify-center text-sm ' + 
                (bairroSelecionado ? 'bg-blue-600 text-white' : 'bg-slate-300 text-slate-600')}>3</span>
              Mensagem e Envio
            </CardTitle>
          </CardHeader>
          <CardContent>
            {!bairroSelecionado ? (
              <div className="text-center py-8 text-slate-500">
                <MessageSquare className="w-8 h-8 mx-auto mb-2 opacity-50" />
                <p>Selecione um bairro primeiro</p>
              </div>
            ) : (
              <div className="space-y-4">
                {/* Info do bairro selecionado */}
                <div className="bg-green-50 border border-green-200 rounded-lg p-3">
                  <p className="font-medium text-green-800">{bairroSelecionado.bairro}</p>
                  <p className="text-sm text-green-600">{bairroSelecionado.total_clientes} clientes disponíveis</p>
                </div>

                {/* Seleção de clientes */}
                <div>
                  <div className="flex items-center justify-between mb-2">
                    <label className="text-sm font-medium text-slate-700">Clientes selecionados</label>
                    <div className="flex gap-2">
                      <button onClick={selecionarTodos} className="text-xs text-blue-600 hover:underline">Todos</button>
                      <span className="text-slate-300">|</span>
                      <button onClick={desmarcarTodos} className="text-xs text-red-600 hover:underline">Nenhum</button>
                    </div>
                  </div>
                  <div className="bg-slate-100 rounded-lg p-2">
                    <p className="text-sm">
                      <span className="font-bold text-blue-600">{clientesSelecionados.length}</span>
                      <span className="text-slate-500"> de {bairroSelecionado.total_clientes} clientes</span>
                    </p>
                  </div>
                  
                  {/* Lista de clientes com checkbox */}
                  <div className="max-h-32 overflow-y-auto mt-2 space-y-1">
                    {bairroSelecionado.clientes.map(function(cliente) {
                      var isChecked = clientesSelecionados.includes(cliente.id);
                      var isManual = cliente.manual;
                      return (
                        <label
                          key={cliente.id}
                          className={'flex items-center gap-2 p-2 rounded cursor-pointer transition-colors ' + 
                            (isChecked ? 'bg-blue-50' : 'hover:bg-slate-50') +
                            (isManual ? ' border-l-2 border-yellow-400' : '')}
                        >
                          <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={function() { toggleCliente(cliente.id); }}
                            className="rounded text-blue-600"
                          />
                          {isManual && <Star className="w-3 h-3 text-yellow-500 fill-yellow-500" title="Cliente adicionado manualmente" />}
                          <span className="text-sm text-slate-700 truncate flex-1">{cliente.nome || 'ID: ' + cliente.id}</span>
                          <span className="text-xs text-slate-400">{cliente.telefone || 'Sem telefone'}</span>
                          {isManual && (
                            <button
                              onClick={function(e) { e.preventDefault(); e.stopPropagation(); removerClienteManual(cliente.id); }}
                              className="p-1 hover:bg-red-100 rounded"
                              title="Remover da lista manual"
                            >
                              <Trash2 className="w-3 h-3 text-red-500" />
                            </button>
                          )}
                        </label>
                      );
                    })}
                  </div>
                </div>

                {/* Campo de mensagem */}
                <div>
                  <div className="flex items-center justify-between mb-2">
                    <label className="text-sm font-medium text-slate-700">
                      Mensagem
                    </label>
                    <button
                      onClick={function() { setShowTemplates(true); carregarTemplates(); }}
                      className="text-xs text-blue-600 hover:underline flex items-center gap-1"
                    >
                      <FileText className="w-3 h-3" />
                      Usar template
                    </button>
                  </div>
                  <textarea
                    value={mensagem}
                    onChange={function(e) { setMensagem(e.target.value); }}
                    placeholder="Digite sua mensagem ou selecione um template..."
                    className="w-full h-24 p-3 border rounded-lg resize-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    data-testid="mensagem-input"
                  />
                  <p className="text-xs text-slate-500 mt-1">{mensagem.length} caracteres</p>
                </div>

                {/* Botão de envio */}
                <Button
                  onClick={enviarMensagem}
                  disabled={enviando || clientesSelecionados.length === 0 || !mensagem.trim()}
                  className="w-full bg-green-600 hover:bg-green-700"
                  data-testid="btn-enviar"
                >
                  {enviando ? (
                    <>
                      <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                      Enviando...
                    </>
                  ) : (
                    <>
                      <Send className="w-4 h-4 mr-2" />
                      Enviar para {clientesSelecionados.length} clientes
                    </>
                  )}
                </Button>

                {/* Resultado do envio */}
                {resultadoEnvio && (
                  <div className="bg-slate-50 border rounded-lg p-3 space-y-2">
                    <p className="font-medium text-slate-800">Resultado do envio:</p>
                    <div className="flex gap-4 text-sm">
                      <div className="flex items-center gap-1 text-green-600">
                        <CheckCircle className="w-4 h-4" />
                        <span>{resultadoEnvio.enviados} enviados</span>
                      </div>
                      <div className="flex items-center gap-1 text-red-600">
                        <XCircle className="w-4 h-4" />
                        <span>{resultadoEnvio.falhas} falhas</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </CardContent>
        </Card>
      </div>

      {/* Modal de Histórico */}
      {showHistorico && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={function() { setShowHistorico(false); setDetalheTransmissao(null); }}>
          <div className="bg-white rounded-xl max-w-4xl w-full max-h-[80vh] overflow-hidden" onClick={function(e) { e.stopPropagation(); }}>
            <div className="p-4 border-b flex items-center justify-between bg-slate-50">
              <h2 className="font-semibold text-lg">Histórico de Transmissões</h2>
              <button onClick={function() { setShowHistorico(false); setDetalheTransmissao(null); }} className="p-2 hover:bg-slate-200 rounded-lg">
                <X className="w-5 h-5" />
              </button>
            </div>
            
            <div className="p-4 overflow-y-auto max-h-[calc(80vh-120px)]">
              {loadingHistorico ? (
                <div className="flex items-center justify-center py-8">
                  <Loader2 className="w-6 h-6 animate-spin text-blue-600" />
                </div>
              ) : detalheTransmissao ? (
                // Detalhe da transmissão
                <div>
                  <button
                    onClick={function() { setDetalheTransmissao(null); }}
                    className="flex items-center gap-2 text-blue-600 hover:underline mb-4"
                  >
                    <ChevronRight className="w-4 h-4 rotate-180" />
                    Voltar para lista
                  </button>
                  
                  <div className="bg-slate-50 rounded-lg p-4 mb-4">
                    <h3 className="font-semibold text-slate-800 mb-2">{detalheTransmissao.transmissao.filial_nome} - {detalheTransmissao.transmissao.bairro}</h3>
                    <p className="text-sm text-slate-600 mb-2">{detalheTransmissao.transmissao.mensagem}</p>
                    <div className="flex gap-4 text-sm">
                      <span className="text-green-600">{detalheTransmissao.transmissao.enviados} enviados</span>
                      <span className="text-red-600">{detalheTransmissao.transmissao.falhas} falhas</span>
                    </div>
                  </div>

                  <div className="space-y-2">
                    <h4 className="font-medium text-slate-700">Logs detalhados ({detalheTransmissao.total_logs})</h4>
                    {detalheTransmissao.logs.map(function(log) {
                      return (
                        <div key={log.id} className={'p-3 rounded-lg border ' + (log.status === 'enviado' ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200')}>
                          <div className="flex items-center justify-between">
                            <div>
                              <p className="font-medium text-slate-800">{log.cliente_nome}</p>
                              <p className="text-sm text-slate-500">{log.cliente_telefone}</p>
                            </div>
                            <div className="text-right">
                              {log.status === 'enviado' ? (
                                <span className="text-green-600 flex items-center gap-1">
                                  <CheckCircle className="w-4 h-4" />
                                  Enviado
                                </span>
                              ) : (
                                <span className="text-red-600 flex items-center gap-1">
                                  <XCircle className="w-4 h-4" />
                                  Falha
                                </span>
                              )}
                              {log.erro && (
                                <p className="text-xs text-red-500 mt-1">{log.erro}</p>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                // Lista de transmissões
                <div className="space-y-3">
                  {historico.length === 0 ? (
                    <p className="text-center text-slate-500 py-8">Nenhuma transmissão realizada ainda</p>
                  ) : (
                    historico.map(function(t) {
                      return (
                        <div
                          key={t.id}
                          className="p-4 border rounded-lg hover:bg-slate-50 cursor-pointer transition-colors"
                          onClick={function() { verDetalheTransmissao(t.id); }}
                        >
                          <div className="flex items-start justify-between">
                            <div>
                              <p className="font-medium text-slate-800">{t.filial_nome} - {t.bairro}</p>
                              <p className="text-sm text-slate-500 mt-1 line-clamp-1">{t.mensagem}</p>
                              <p className="text-xs text-slate-400 mt-2">
                                Por {t.created_by_nome} em {new Date(t.created_at).toLocaleString('pt-BR')}
                              </p>
                            </div>
                            <div className="text-right">
                              <div className={'px-2 py-1 rounded-full text-xs ' + 
                                (t.status === 'concluido' ? 'bg-green-100 text-green-700' : 
                                 t.status === 'em_andamento' ? 'bg-blue-100 text-blue-700' : 
                                 'bg-red-100 text-red-700')}>
                                {t.status === 'concluido' ? 'Concluído' : t.status === 'em_andamento' ? 'Em andamento' : 'Erro'}
                              </div>
                              <div className="mt-2 text-sm">
                                <span className="text-green-600">{t.enviados}</span>
                                <span className="text-slate-400"> / </span>
                                <span className="text-slate-600">{t.total_clientes}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal Adicionar Cliente */}
      {showAdicionarCliente && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={function() { setShowAdicionarCliente(false); }}>
          <div className="bg-white rounded-xl max-w-md w-full" onClick={function(e) { e.stopPropagation(); }}>
            <div className="p-4 border-b flex items-center justify-between bg-slate-50 rounded-t-xl">
              <h2 className="font-semibold text-lg flex items-center gap-2">
                <UserPlus className="w-5 h-5 text-blue-600" />
                Adicionar Cliente Manualmente
              </h2>
              <button onClick={function() { setShowAdicionarCliente(false); }} className="p-2 hover:bg-slate-200 rounded-lg">
                <X className="w-5 h-5" />
              </button>
            </div>
            
            <div className="p-4 space-y-4">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                <p className="text-sm text-blue-700">
                  <strong>Filial selecionada:</strong> {filialSelecionada?.nome_fantasia || filialSelecionada?.nome}
                </p>
              </div>
              
              <div>
                <label className="text-sm font-medium text-slate-700 block mb-1">ID do Cliente no IXC *</label>
                <Input
                  value={novoCliente.id}
                  onChange={function(e) { setNovoCliente(Object.assign({}, novoCliente, { id: e.target.value })); }}
                  placeholder="Ex: 12345"
                />
              </div>
              
              <div>
                <label className="text-sm font-medium text-slate-700 block mb-1">Nome do Cliente</label>
                <Input
                  value={novoCliente.nome}
                  onChange={function(e) { setNovoCliente(Object.assign({}, novoCliente, { nome: e.target.value })); }}
                  placeholder="Ex: João Silva"
                />
              </div>
              
              <div>
                <label className="text-sm font-medium text-slate-700 block mb-1">Telefone/WhatsApp</label>
                <Input
                  value={novoCliente.telefone}
                  onChange={function(e) { setNovoCliente(Object.assign({}, novoCliente, { telefone: e.target.value })); }}
                  placeholder="Ex: 11999999999"
                />
              </div>
              
              <div>
                <label className="text-sm font-medium text-slate-700 block mb-1">Bairro</label>
                <Input
                  value={novoCliente.bairro}
                  onChange={function(e) { setNovoCliente(Object.assign({}, novoCliente, { bairro: e.target.value })); }}
                  placeholder="Ex: CENTRO"
                />
              </div>
              
              <p className="text-xs text-slate-500">
                * O cliente deve ter um contrato FIBRA ativo no IXC para aparecer na lista.
                Se o contrato for cancelado, o cliente será removido automaticamente.
              </p>
              
              <div className="flex gap-2 pt-2">
                <Button onClick={adicionarClienteManual} className="flex-1 bg-blue-600 hover:bg-blue-700">
                  <UserPlus className="w-4 h-4 mr-2" />
                  Adicionar
                </Button>
                <Button variant="outline" onClick={function() { setShowAdicionarCliente(false); }}>
                  Cancelar
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* Modal de Templates */}
      {showTemplates && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={function() { setShowTemplates(false); setEditandoTemplate(null); }}>
          <div className="bg-white rounded-xl max-w-4xl w-full max-h-[85vh] overflow-hidden" onClick={function(e) { e.stopPropagation(); }}>
            <div className="p-4 border-b flex items-center justify-between bg-slate-50">
              <h2 className="font-semibold text-lg flex items-center gap-2">
                <FileText className="w-5 h-5" />
                Gerenciar Templates de Mensagens
              </h2>
              <button onClick={function() { setShowTemplates(false); setEditandoTemplate(null); }} className="p-2 hover:bg-slate-200 rounded-lg">
                <X className="w-5 h-5" />
              </button>
            </div>
            
            <div className="p-4 overflow-y-auto max-h-[calc(85vh-140px)]">
              {/* Barra de busca e filtro */}
              <div className="flex flex-col md:flex-row gap-2 mb-4">
                <div className="relative flex-1">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                  <Input
                    value={searchTemplate}
                    onChange={function(e) { setSearchTemplate(e.target.value); }}
                    placeholder="Buscar por título..."
                    className="pl-10"
                  />
                </div>
                <select
                  value={filtroCategoria}
                  onChange={function(e) { setFiltroCategoria(e.target.value); carregarTemplates(); }}
                  className="px-3 py-2 border rounded-lg text-sm"
                >
                  <option value="">Todas categorias</option>
                  {CATEGORIAS.map(function(cat) {
                    return <option key={cat} value={cat}>{cat}</option>;
                  })}
                </select>
              </div>
              
              {/* Criar novo template */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
                <h3 className="font-medium text-blue-800 mb-3 flex items-center gap-2">
                  <Plus className="w-4 h-4" />
                  Criar Novo Template
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                  <Input
                    value={novoTemplate.titulo}
                    onChange={function(e) { setNovoTemplate(Object.assign({}, novoTemplate, { titulo: e.target.value })); }}
                    placeholder="Título do template"
                  />
                  <select
                    value={novoTemplate.categoria}
                    onChange={function(e) { setNovoTemplate(Object.assign({}, novoTemplate, { categoria: e.target.value })); }}
                    className="px-3 py-2 border rounded-lg text-sm"
                  >
                    {CATEGORIAS.map(function(cat) {
                      return <option key={cat} value={cat}>{cat}</option>;
                    })}
                  </select>
                  <Button onClick={criarTemplate} className="bg-blue-600 hover:bg-blue-700">
                    <Plus className="w-4 h-4 mr-2" />
                    Criar
                  </Button>
                </div>
                <textarea
                  value={novoTemplate.mensagem}
                  onChange={function(e) { setNovoTemplate(Object.assign({}, novoTemplate, { mensagem: e.target.value })); }}
                  placeholder="Texto da mensagem..."
                  className="w-full h-20 p-3 border rounded-lg resize-none mt-3"
                />
              </div>
              
              {/* Lista de templates */}
              {loadingTemplates ? (
                <div className="flex items-center justify-center py-8">
                  <Loader2 className="w-6 h-6 animate-spin text-blue-600" />
                </div>
              ) : getTemplatesFiltrados().length === 0 ? (
                <div className="text-center py-8 text-slate-500">
                  <FileText className="w-12 h-12 mx-auto mb-2 opacity-30" />
                  <p>Nenhum template encontrado</p>
                  <p className="text-sm">Crie um novo template acima</p>
                </div>
              ) : (
                <div className="space-y-3">
                  {getTemplatesFiltrados().map(function(template) {
                    var isEditando = editandoTemplate && editandoTemplate.id === template.id;
                    var categoriaCor = {
                      'Manutenção': 'bg-orange-100 text-orange-700',
                      'Promoção': 'bg-green-100 text-green-700',
                      'Cobrança': 'bg-red-100 text-red-700',
                      'Geral': 'bg-slate-100 text-slate-700'
                    }[template.categoria] || 'bg-slate-100 text-slate-700';
                    
                    if (isEditando) {
                      return (
                        <div key={template.id} className="border-2 border-blue-400 rounded-lg p-4 bg-blue-50">
                          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-3">
                            <Input
                              value={editandoTemplate.titulo}
                              onChange={function(e) { setEditandoTemplate(Object.assign({}, editandoTemplate, { titulo: e.target.value })); }}
                              placeholder="Título"
                            />
                            <select
                              value={editandoTemplate.categoria}
                              onChange={function(e) { setEditandoTemplate(Object.assign({}, editandoTemplate, { categoria: e.target.value })); }}
                              className="px-3 py-2 border rounded-lg text-sm"
                            >
                              {CATEGORIAS.map(function(cat) {
                                return <option key={cat} value={cat}>{cat}</option>;
                              })}
                            </select>
                            <div className="flex gap-2">
                              <Button onClick={function() { atualizarTemplate(template.id); }} size="sm" className="flex-1 bg-green-600 hover:bg-green-700">
                                <Save className="w-4 h-4 mr-1" />
                                Salvar
                              </Button>
                              <Button onClick={function() { setEditandoTemplate(null); }} size="sm" variant="outline">
                                <X className="w-4 h-4" />
                              </Button>
                            </div>
                          </div>
                          <textarea
                            value={editandoTemplate.mensagem}
                            onChange={function(e) { setEditandoTemplate(Object.assign({}, editandoTemplate, { mensagem: e.target.value })); }}
                            className="w-full h-20 p-3 border rounded-lg resize-none"
                          />
                        </div>
                      );
                    }
                    
                    return (
                      <div key={template.id} className="border rounded-lg p-4 hover:border-blue-300 transition-colors">
                        <div className="flex items-start justify-between mb-2">
                          <div className="flex items-center gap-2">
                            <h4 className="font-medium text-slate-800">{template.titulo}</h4>
                            <span className={'text-xs px-2 py-0.5 rounded-full ' + categoriaCor}>
                              {template.categoria}
                            </span>
                          </div>
                          <div className="flex gap-1">
                            <button
                              onClick={function() { usarTemplate(template); }}
                              className="p-1.5 hover:bg-green-100 rounded text-green-600"
                              title="Usar este template"
                            >
                              <Check className="w-4 h-4" />
                            </button>
                            <button
                              onClick={function() { setEditandoTemplate(Object.assign({}, template)); }}
                              className="p-1.5 hover:bg-blue-100 rounded text-blue-600"
                              title="Editar"
                            >
                              <Edit2 className="w-4 h-4" />
                            </button>
                            <button
                              onClick={function() { excluirTemplate(template.id); }}
                              className="p-1.5 hover:bg-red-100 rounded text-red-600"
                              title="Excluir"
                            >
                              <Trash2 className="w-4 h-4" />
                            </button>
                          </div>
                        </div>
                        <p className="text-sm text-slate-600 whitespace-pre-wrap line-clamp-3">{template.mensagem}</p>
                        {template.criado_por && (
                          <p className="text-xs text-slate-400 mt-2">Criado por: {template.criado_por}</p>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default TransmissaoPage;
